import { Component, ViewChild, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedZorroModule } from '../../shared-zorro.module';
import { RouterModule, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { UserService } from '../../service/user.service';
import dayjs from 'dayjs';
import { TableHeaderSettingComponent } from '../component/table-header-setting/table-header-setting.component';
import { SearchGroupSettingComponent } from '../component/search-group-setting/search-group-setting.component';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { tableHeader } from '../../config/tableHader';
@Component({
  selector: 'app-workspace',
  standalone: true,
  imports: [CommonModule, SharedZorroModule, RouterModule],
  templateUrl: './workspace.component.html',
  styleUrl: './workspace.component.less',
})
export class WorkspaceComponent {
  @ViewChild('drawerFooter', { static: true }) drawerFooter!: TemplateRef<{}>;
  @ViewChild('searchGroupDrawerFooter', { static: true }) searchGroupDrawerFooter!: TemplateRef<{}>;

  user: any;
  role: any;
  searchParams: any = {
    patientName: '',
    date: [],
    deviceTypes: [],
    pageSize: 10,
    pageIndex: 1,
  };
  quickDateType: string = 'year';
  deviceList: any[] = [
    {
      label: 'CT',
      value: 'CT',
    },
    {
      label: 'DR',
      value: 'DR',
    },
    {
      label: 'CR',
      value: 'CR',
    },
    {
      label: 'RF',
      value: 'RF',
    },
    {
      label: 'MR',
      value: 'MR',
    },
    {
      label: 'US',
      value: 'US',
    },
    {
      label: 'NM',
      value: 'NM',
    },
    {
      label: 'XA',
      value: 'XA',
    },
    {
      label: 'OT',
      value: 'OT',
    },
  ];
  workTableHeader: any[] = [
    {
      label: '状态',
      prop: 'status',
      width: 100,
      isShow: true,
      allowDrag: false,
      index: 0,
    },
    {
      label: '姓名',
      prop: 'patientName',
      width: 100,
      isShow: true,
      allowDrag: true,
      index: 1,
    },
    {
      label: '性别',
      prop: 'patientGender',
      width: 100,
      isShow: true,
      allowDrag: true,
      index: 2,
    },
  ];
  showTotal: boolean = true;
  dataList: any[] = [];
  status: any = {
    UPLOADED: '已上传',
    REPORTED: '已报告',
    AUDITED: '已审核',
    RECALLED: '已撤回',
    REJECTED: '已驳回',
  };
  lockedCaseList: any[] = [];
  totalLockedCase: number = 0;
  total: number = 0;
  searchGroups: any[] = [];
  selectedGroup: any = {
    id: '',
  };
  pageSize: number = 10;
  pageIndex: number = 1;
  tableHeaderDrawer: any;
  searchGroupDrawer: any;
  searchGroupItem: any = {};
  tableName: string = 'workbench'; //定义全局唯一表格名称
  constructor(private router: Router, private userService: UserService, private message: NzMessageService, private drawerService: NzDrawerService) {
    this.user = JSON.parse(sessionStorage.getItem('user') || '{}');
    this.role = JSON.parse(sessionStorage.getItem('role') || '{}');
    this.setDefaultDate();
    this.getDiagnosisList();
    this.getLockedDiagnosis();
    this.getSearchGroups();
    this.getTableHeader('workbench');
  }

  ngOnInit() {}

  search() {
    this.getDiagnosisList();
  }
  reset() {
    this.searchParams = {
      patientName: '',
      date: [],
      deviceTypes: [],
      pageSize: 10,
      pageIndex: 1,
    };
    this.setDefaultDate();
    this.getDiagnosisList();
  }
  //设置默认时间
  setDefaultDate() {
    this.searchParams.date = [dayjs().subtract(1, 'year').toDate(), dayjs().toDate()];
  }
  //快速选择时间范围
  quickDateChange(type: string) {
    this.quickDateType = type;
    switch (type) {
      case 'today':
        this.searchParams.date = [dayjs().toDate(), dayjs().toDate()];
        break;
      case 'month':
        this.searchParams.date = [dayjs().subtract(1, 'month').toDate(), dayjs().toDate()];
        break;
      case 'year':
        this.searchParams.date = [dayjs().subtract(1, 'year').toDate(), dayjs().toDate()];
        break;
    }
  }
  pageIndexChange(val: any) {
    this.searchParams.pageIndex = val;
    this.getDiagnosisList();
  }
  pageSizeChange(val: any) {
    this.searchParams.pageSize = val;
    this.getDiagnosisList();
  }

  workPageIndexChange(val: any) {
    this.pageIndex = val;
  }

  workPageSizeChange(val: any) {
    this.pageSize = val;
  }

  //获取诊断列表
  getDiagnosisList() {
    let params: any = {
      page: this.searchParams.pageIndex,
      size: this.searchParams.pageSize,
      patientName: this.searchParams.patientName,
      submitDateStart: dayjs(this.searchParams.date[0]).format('YYYY-MM-DD'),
      submitDateEnd: dayjs(this.searchParams.date[1]).format('YYYY-MM-DD'),
      deviceTypes: this.searchParams.deviceTypes.join(','),
    };
    if (this.selectedGroup.id) {
      params.criteriaSettingId = this.selectedGroup.id;
      // params.examinationStatuses = this.selectedGroup.predicates.examinationStatuses.join(',');
      // params.examinationTypes = this.selectedGroup.predicates.examinationTypes.join(',');
      // params.sourceHospitalIdList = this.selectedGroup.predicates.sourceHospitalIdList.join(',');
      // params.doctors = this.selectedGroup.predicates.doctors.join(',');
      // params.deviceTypes = this.selectedGroup.predicates.deviceTypes.join(',');
    }
    this.userService.getDiagnosisList(params).subscribe(
      (res) => {
        if (res.code === 0) {
          this.dataList = res.data.content;
          this.total = res.data.totalElements;
        } else {
          this.message.error(res.msg);
        }
      },
      (err) => {
        this.message.error('获取诊断列表失败');
      }
    );
  }

  //查询用户的查询组
  getSearchGroups() {
    let params: any = {
      tableName: this.tableName,
    };
    this.userService.getSearchGroups(params).subscribe((res) => {
      if (res.code === 0) {
        this.searchGroups = res.data;
      } else {
        this.message.error(res.msg);
      }
    });
  }

  //查询已锁定的病例
  getLockedDiagnosis() {
    let params = {
      size: this.pageSize,
      page: this.pageIndex,
    };
    this.userService.getLockedDiagnosis(params).subscribe((res) => {
      if (res.code === 0) {
        this.lockedCaseList = res.data;
        this.totalLockedCase = res.data.totalElements;
      } else {
        this.message.error(res.msg);
      }
    });
  }

  //解锁报告
  unlockReport(id: string) {
    this.userService.unlockReport(id).subscribe((res) => {
      if (res.code === 0) {
        this.message.success('解锁成功');
        this.getLockedDiagnosis();
        this.getDiagnosisList();
      } else {
        this.message.error(res.msg);
      }
    });
  }

  //锁定报告
  lockReport(id: string) {
    this.userService.lockReport(id).subscribe((res) => {
      if (res.code === 0) {
        this.openDiagnosisDetail(id);
      } else {
        this.message.error(res.message);
      }
    });
  }

  //打开阅片界面
  openDiagnosisDetail(id: string) {
    this.router.navigate(['/admin/case/detail', id]);
  }

  //格式化性别
  formatGender(value: any) {
    return this.userService.formatGender(value);
  }

  //getStatusClass
  getStatusClass(value: any) {
    return this.userService.getStatusClass(value);
  }

  //格式化时间
  formatTime(value: any) {
    return dayjs(value).format('YYYY-MM-DD HH:mm:ss');
  }

  //设置表格头部
  settingTableHeader(type: string) {
    //打开右侧侧栏
    this.tableHeaderDrawer = this.drawerService.create({
      nzTitle: '设置表头',
      nzContent: TableHeaderSettingComponent,
      nzWidth: '300px',
      nzClosable: true,
      nzData: {
        tableHeader: this.workTableHeader,
      },
      nzFooter: this.drawerFooter,
    });
  }

  //读取设置的表头
  getTableHeader(type: string) {
    this.userService.getTableHeader(type).subscribe((res: any) => {
      if (type === 'workbench') {
        this.workTableHeader = res.data && res.data.length > 0 ? res.data : tableHeader.workbench;
      }
    });
  }

  onSubmit() {
    let data = this.workTableHeader.map((item: any, index: number) => {
      return {
        label: item.label,
        prop: item.prop,
        width: item.width,
        isShow: item.isShow,
        index: index,
      };
    });
    this.userService
      .saveTableHeader({
        tableName: 'workbench',
        data: data,
      })
      .subscribe((res) => {
        if (res.code === 0) {
          this.message.success('保存成功');
        } else {
          this.message.error(res.msg);
        }
      });
  }

  onCancel() {
    //关闭右侧侧栏
    this.tableHeaderDrawer.close();
  }

  //新增查询组
  addGroup() {
    this.searchGroupItem = {
      name: '',
      tableName: 'workbench',
      predicates: {
        examinationStatuses: [],
        examinationTypes: [],
        sourceHospitalIdList: [],
        doctors: [],
        deviceTypes: [],
      },
    };
    this.editGroup(this.searchGroupItem);
  }

  //编辑查询组
  editGroup(item: any) {
    this.searchGroupItem = item;
    //打开右侧侧栏
    this.searchGroupDrawer = this.drawerService.create({
      nzTitle: '设置查询组',
      nzContent: SearchGroupSettingComponent,
      nzWidth: '400px',
      nzClosable: true,
      nzData: {
        data: this.searchGroupItem,
      },
      nzFooter: this.searchGroupDrawerFooter,
    });
  }

  //删除查询组
  deleteGroup() {
    this.userService.deleteSearchGroup(this.searchGroupItem.id).subscribe((res: any) => {
      if (res.code === 0) {
        this.message.success('删除成功');
        this.getSearchGroups();
        this.searchGroupDrawer.close();
      } else {
        this.message.error(res.msg);
      }
    });
  }

  onSubmitSearchGroup() {
    let searchParams = this.searchGroupDrawer.getContentComponent().getValues();
    let params: any = {
      name: searchParams.name,
      tableName: this.tableName,
      predicates: searchParams.predicates,
    };
    if (this.searchGroupItem.id) {
      params.id = this.searchGroupItem.id;
    }
    this.userService.addSearchGroup(params).subscribe((res) => {
      if (res.code === 0) {
        this.message.success('保存成功');
        this.getSearchGroups();
        this.searchGroupDrawer.close();
      } else {
        this.message.error(res.msg);
      }
    });
  }

  onCancelSearchGroup() {
    this.searchGroupDrawer.close();
  }

  recallReport(id: string) {
    this.userService.recallReport(id).subscribe((res: any) => {
      if (res.code === 0) {
        this.message.success('召回成功');
        this.getLockedDiagnosis();
        this.getDiagnosisList();
      } else {
        this.message.error(res.msg);
      }
    });
  }

  //审核报告
  auditReport(id: string) {
    this.userService.lockReport(id).subscribe((res) => {
      if (res.code === 0) {
        this.openDiagnosisDetail(id);
      } else {
        this.message.error(res.message);
      }
    });
  }

  //判断个人工作台是否可以解锁
  canUnlockBtn(item: any) {
    return item.status == 'UPLOADED' && item.lockedUserId == this.user.id;
  }

  //判断个人工作台是否可以诊断
  canDiagnosisBtn(item: any) {
    return item.status != 'UPLOADED' || item.lockedUserId == this.user.id;
  }

  //判断个人工作台是否可以召回
  canRecallBtn(item: any) {
    return item.status == 'REPORTED' && item.reporterId == this.user.id;
  }

  //case pool 是否可以审核
  canCasePoolAuditBtn(item: any) {
    if (item.status == 'REPORTED' && this.role.roleCode == 'auditor') {
      return true;
    }
    if (item.status == 'UPLOADED' && !item.lockedUserId) {
      return true;
    }
    return false;
  }

  //case pool 是否可以诊断
  canCasePoolDiagnosisBtn(item: any) {
    if (item.status == 'UPLOADED' && !item.lockedUserId) {
      return true;
    }
    if (item.status == 'RECALLED' && item.lockedUserId == this.user.id) {
      return true;
    }
    return false;
  }
}
